import { memo, type FC } from "react";
import { useTranslation } from "react-i18next";
import CampaignStepCard from "src/layouts/Engagements/Campaigns/shared/CampaignStepCard";
import type { SegmentPreview } from "../CreateSegment.Constants";
import { useSegmentFormatters, useSegmentLabel } from "../UseSegmentLabel";

interface SegmentReviewStepProps {
  segmentName: string;
  segmentMeta: string;
  preview: SegmentPreview;
  summary: string;
}

const SegmentReviewStep: FC<SegmentReviewStepProps> = ({ segmentName, segmentMeta, preview, summary }) => {
  const { i18n } = useTranslation();
  const label = useSegmentLabel();
  const { formatValue } = useSegmentFormatters();
  const unreachableCount = preview.people - preview.whatsapp;
  const rulesText = `${summary.charAt(0).toLocaleLowerCase(i18n.language)}${summary.slice(1)}`;

  return (
    <CampaignStepCard title={label("review.title")}>
      <div className="create-list__stats">
        <div className="create-list__stat">
          <strong className="create-list__stat-value">{formatValue(preview.people)}</strong>
          <span className="create-list__stat-label">{label("review.matchToday")}</span>
        </div>
        <div className="create-list__stat">
          <strong className="create-list__stat-value segment-builder__text-brand">
            {formatValue(preview.email)}
          </strong>
          <span className="create-list__stat-label">{label("review.reachedByEmail")}</span>
        </div>
        <div className="create-list__stat">
          <strong className="create-list__stat-value create-list__stat-value--positive">
            {formatValue(preview.whatsapp)}
          </strong>
          <span className="create-list__stat-label">{label("review.reachedByWhatsapp")}</span>
        </div>
      </div>

      <div className="create-list__review-notes">
        <p>
          <strong>{label("review.rules")}</strong> {rulesText}
        </p>
        <p>
          <strong className="segment-builder__text-brand">{label("review.updatesTitle")}</strong>{" "}
          {label("review.updatesDetail")}
        </p>
        {unreachableCount > 0 && (
          <p>
            {label("review.whatsappUnreachable", {
              count: unreachableCount,
              value: formatValue(unreachableCount),
            })}
          </p>
        )}
      </div>

      <div className="create-list__summary">
        <span className="create-list__summary-text" dir="auto">
          <strong>{segmentName}</strong> · {segmentMeta}
        </span>
      </div>
    </CampaignStepCard>
  );
};

export default memo(SegmentReviewStep);
